<template>
  <div class="modal-overlay" v-if="showSubscribeSuccessModal" @click.self="close">
    <div class="modal-content">
      <button class="close-btn" @click="close">&times;</button>
      <div class="modal-header">
        <h2><span class="sports">SPORTS</span><span class="hub">HUB</span></h2>
        <h3 class="success-title">Congratulations!</h3>
      </div>
      <div class="modal-body">
        <p class="success-message">
          You have successfully subscribed to <strong>Sports Hub</strong>! You will now have full access to all premium features, Ad-free TV, and all four Sports Zones.
        </p>
        <p class="please-note">
          <strong>Please note:</strong> Any existing subscriptions to individual Sports Zones will be cancelled to prevent duplicate billing.
        </p>
        <button class="close-btn-red" @click="close">CLOSE</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import modalMixin from '@/mixins/modalMixin'

export default {
  name: 'SubscribeSuccessModal',
  mixins: [modalMixin],
  computed: {
    ...mapState(['showSubscribeSuccessModal'])
  },
  methods: {
    ...mapMutations(['closeAllModals'])
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/modal-common';

.success-title {
  font-size: 20px;
  font-weight: 700;
  color: $brand-dark;
  margin: 0 0 $space-base 0;
  text-align: center;
}

.modal-body {
  text-align: center;
}

.success-message {
  color: $brand-dark;
  font-size: 15px;
  font-weight: 400;
  margin: 0 0 $space-base 0;
  line-height: 1.5;
  background: none;
  padding: 0;
  border: none;
  border-radius: 0;

  strong {
    font-weight: 700;
  }
}

.please-note {
  color: $brand-red;
  font-size: 14px;
  font-weight: 400;
  margin: 0 0 $space-lg 0;
  line-height: 1.5;

  strong {
    font-weight: 700;
  }
}

.close-btn-red {
  @include primary-btn;
}
</style>
